import { Link } from "react-router-dom/cjs/react-router-dom.min";
import DashboardTile from "./DashboardTile";
import axios from 'axios';
import { useContext, useEffect, useState } from "react";
import MyContext from "./../MyContext";
import "./PerformanceDashboard.scss"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Targets from "../Others/Targets";
import Select from "react-select";


function PerformanceDashboard(){
    const [data, setData] = useState([]);
    const [month, setMonth] = useState(new Date());
    const [executives, setExecutives] = useState([]);
    const [executive, setExecutive] = useState('');

    const { loading, user_details } = useContext(MyContext);
    const fetchData = async (month) => {
        const request_data = new FormData();
        request_data.append('sid',user_details.sid);
        request_data.append('month',new Date(month).toLocaleDateString('en-US'));
        request_data.append('executive',executive.value??'');
        // this.state.monthYear.toLocaleDateString('en-US')
        const url = `${process.env.REACT_APP_SSS}/api/getPerformanceDashBoard`;
        try {
          const response = await axios.post(url,request_data);
          convertData(response.data.data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }finally{
          loading(0);
        }
    };
    useEffect(() => {
      loading(1);
      getExecutives();
    }, []);
    const onExecutiveChange = (value) =>{
      setExecutive(value)
    }
    const getExecutives = () =>{
      const url = `${process.env.REACT_APP_SSS}/api/get/executives`;
      loading(1);
      $.ajax({
        url : url,
        data : {
          sid : user_details.sid
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        if(return_data.status == "success"){
          setExecutives(return_data.executives);
          loading(0);
        }else{
          loading(0);
        }
       }).fail(function(){
        alert("Network error");
        loading(0);
      });
    }
   
    function convertData(data){
      const newData = [{
        title : "Total Customer",
        value : data.no_of_dealers
      },
      {
        title : "Total Lead",
        value : data.no_of_leads
      },
      {
        title : "Attendance",
        value : data.attendance_count
      },
      {
        title : "Leave",
        value : data.leave_count
      },
      {
        title : "Productive Call",
        value : data.productive_calls
      },
      {
        title : "Completed Visits",
        value : data.completed_visits
      }, 
,      {
        title : "Scheduled Visit",
        value : data.scheduled_total_visit_customer
      },
      {
        title : "Pending Total Visit",
        value : data.total_pending_visit_customer
      },
       {
        title : "Customer Coverage",
        value : data.dealer_coverage
      }, {
        title : "Lead Coverage",
        value : data.lead_coverage
      },
      {
        title : "Strike Rate",
        value : data.strike_rate
      },
      {
        title : "TLS",
        value : data.tls
      },
      {
        title : "Unbilled Outlets",
        value : data.unbilled_outlet_count
      },
      {
        title : "ECO",
        value : data.eco_count
      },
      {
        title : "New Outlets",
        value : data.new_outlet_count
      },
      ]
      setData(newData)
    }

    useEffect(() => {
      loading(1);
      fetchData(month);
    }, [month,executive]);

    const onMonthChange = (date) =>{
      setMonth(date)
    }

    
    return(
        <div className="performance_dashboard_page_container">
            <div className="page_header">
              <div className="page_title">
                <Link className="back_button" to="/dashboard" style={{ marginRight: '15px', color: 'inherit', textDecoration: 'none' }}>
                  <i className="fas fa-arrow-left"></i>
                </Link>
                Performance Dashboard
              </div>
            </div>
            <form className="month_select_form">
              <div className="blocks">
                <div className="input_grid">
                  <div className="input_label">Month</div>
                  <DatePicker
                    selected={month}
                    value = {month}
                    onChange={onMonthChange}
                    dateFormat=" MM / y"
                    showMonthYearPicker
                    // focusSelectedMonth
                    className="datepicker-custom-style"
                    dropdownMode="select"
                    minDate={new Date(new Date().getFullYear()-1, new Date().getMonth(), 1 )}
                    maxDate={new Date()}
                  />
                </div>
                <div className="input_grid">
                  <div className="input_label">Executive</div>
                  <Select
                    options={executives}
                    value={executive}
                    className="executive"
                    // ref={this.executiveSelect}
                    onChange={onExecutiveChange}
                    required
                  />
                </div>
              </div>
              
            </form>
            <div className="dashboard_tile_container">
            {
              data.map((item,idx)=>
                <DashboardTile key={idx} heading={item.title} content={item.value} />
              )
            }
            </div>
            <Targets month={month} executive = {executive} isSearchDisabled = {false}/>
              {/* </Targets> */}
            
        </div>
    )
}

export default PerformanceDashboard;